import { TouchpointKind } from "@sp-crm/core";

const roundDown = (value: number): number => Math.floor(value);

const tierVolumeKindOrder: TouchpointKind[] = ["visit", "call", "text", "email"];

const touchpointKindLabels: Record<TouchpointKind, { singular: string; plural: string }> =
    {
        visit: { singular: "visit", plural: "visits" },
        call: { singular: "call", plural: "calls" },
        text: { singular: "text", plural: "texts" },
        email: { singular: "email", plural: "emails" },
    };

export interface TierTouchpointVolumeGroup {
    kinds: TouchpointKind[];
    volume: number;
}

const kindOrderIndex = (kinds: string[]): number =>
    tierVolumeKindOrder.findIndex(kind => kinds.includes(kind));

export const scaleTierVolumeGroups = (
    groups: TierTouchpointVolumeGroup[],
    fraction: number,
): TierTouchpointVolumeGroup[] =>
    groups.map(group => ({ kinds: group.kinds, volume: group.volume * fraction }));

export const formatTierVolume = (groups: TierTouchpointVolumeGroup[]): string => {
    const nonZeroGroups = groups.filter(group => group.volume > 0);
    if (nonZeroGroups.length === 0) {
        return "no cadence configured";
    }
    const sortedGroups = [...nonZeroGroups].sort(
        (a, b) => kindOrderIndex(a.kinds) - kindOrderIndex(b.kinds),
    );
    const parts = sortedGroups.map(group => {
        const count = roundDown(group.volume);
        const isSingular = count === 1;
        const labels = tierVolumeKindOrder
            .filter(kind => group.kinds.includes(kind))
            .map(kind =>
                isSingular
                    ? touchpointKindLabels[kind].singular
                    : touchpointKindLabels[kind].plural,
            );
        return `${count} ${labels.join("/")}`;
    });
    return parts.join(", ");
};
